import { useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import Navbar from '../../../components/navbar/navbar'
import { CapacidadePicking } from './components/CapacidadePicking'
import { CompactarEnderecos } from './components/CompactarEnderecos'
import { EstoqueNegativo } from './components/EstoqueNegativo'
import { EstoquePorEndereco } from './components/EstoquePorEndereco'
import { EstoquePorProduto } from './components/EstoquePorProduto'
import { HistoricoMovimentacao } from './components/HistoricoMovimentacao'
import { Ocupacao } from './components/Ocupacao'
import { OcupacaoPorEndereco } from './components/OcupacaoPorEndereco'
import { Produtividade } from './components/Produtividade'

export function WMSRelatorios() {
  const [key, setKey] = useState('ocup-end')

  return (
    <>
      <Navbar />

      <h1>Relatórios</h1>

      <Tabs
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-3"
      >
        <Tab
          eventKey="ocup-end"
          title="Ocupação de Endereço"
        >
          <OcupacaoPorEndereco />
        </Tab>

        <Tab
          eventKey="ocup"
          title="Ocupação"
        >
          <Ocupacao />
        </Tab>

        <Tab
          eventKey="produtividade"
          title="Produtividade"
        >
          <Produtividade />
        </Tab>

        <Tab
          eventKey="estq-ngtv"
          title="Estoque Negativo"
        >
          <EstoqueNegativo />
        </Tab>

        <Tab
          eventKey="compac-end"
          title="Compactação de Endereços"
        >
          <CompactarEnderecos />
        </Tab>

        <Tab
          eventKey="capcd-pick"
          title="Capacidade de Picking"
        >
          <CapacidadePicking />
        </Tab>

        <Tab
          eventKey="estq-end"
          title="Estoque por Endereço"
        >
          <EstoquePorEndereco />
        </Tab>

        <Tab
          eventKey="estq-prod"
          title="Estoque por Produto"
        >
          <EstoquePorProduto />
        </Tab>

        <Tab
          eventKey="hist-mov"
          title="Histórico de Movimentação"
        >
          <HistoricoMovimentacao />
        </Tab>
      </Tabs>
    </>
  )
}
